"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zilo = void 0;
var util_1 = require("@zilliqa-js/util");
var bignumber_js_1 = require("bignumber.js");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
/**
 * Zilo class to represent an instance of a ZilSwap Initial Launch Offering.
 *
 * Usage:
 * ```
 * const zilswap = new Zilswap(Network.TestNet)
 * await zilswap.initialize()
 * const zilo = await zilswap.registerZilo(ZILO_ADDRESS, ziloStateObserver)
 *
 * const ziloState = zilo.getZiloState()
 *
 * if (ziloState.state === ILOState.Active) {
 *    const amount = new BigNumber(1).shiftedBy(ZIL_DECIMALS).toString(10)
 *    const tx = await zilo.contribute(amount)
 *
 *    console.log("distribute TX sent", tx.hash)
 * } else {
 *    console.log("ZILO not yet active")
 * }
 * ```
 */
var Zilo = /** @class */ (function () {
    function Zilo(zilswap, address) {
        this.zilswap = zilswap;
        this.contract = zilswap.getContract(address);
    }
    Zilo.prototype.initialize = function (observer) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.updateObserver(observer);
                        return [4 /*yield*/, this.updateZiloState()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Zilo.prototype.updateObserver = function (observer) {
        this.stateObserver = observer;
    };
    Zilo.prototype.fetchContractInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, rawInit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.zilswap.fetchContractInit(this.contract)];
                    case 1:
                        result = _a.sent();
                        if (!result)
                            return [2 /*return*/];
                        rawInit = utils_1.contractInitToMap(result);
                        return [2 /*return*/, __assign(__assign({}, rawInit), { token_amount: new bignumber_js_1.BigNumber(rawInit.token_amount), target_zil_amount: new bignumber_js_1.BigNumber(rawInit.target_zil_amount), target_zwap_amount: new bignumber_js_1.BigNumber(rawInit.target_zwap_amount), minimum_zil_amount: new bignumber_js_1.BigNumber(rawInit.minimum_zil_amount), liquidity_zil_amount: new bignumber_js_1.BigNumber(rawInit.liquidity_zil_amount), start_block: parseInt(rawInit.start_block, 10), end_block: parseInt(rawInit.end_block, 10) })];
                }
            });
        });
    };
    Zilo.prototype.fetchContractState = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result, contributions, _i, _b, byStr20Address, balances, _c, _d, byStr20Address;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.contract.getState()];
                    case 1:
                        result = _e.sent();
                        contributions = {};
                        for (_i = 0, _b = Object.keys(result.contributions); _i < _b.length; _i++) {
                            byStr20Address = _b[_i];
                            contributions[byStr20Address] = new bignumber_js_1.BigNumber(result.contributions[byStr20Address]);
                        }
                        balances = {};
                        for (_c = 0, _d = Object.keys((_a = result.balances) !== null && _a !== void 0 ? _a : {}); _c < _d.length; _c++) {
                            byStr20Address = _d[_c];
                            balances[byStr20Address] = new bignumber_js_1.BigNumber(result.balances[byStr20Address]);
                        }
                        return [2 /*return*/, __assign(__assign(__assign({}, result), { contributions: contributions }), !!result.balances && {
                                balances: balances,
                            })];
                }
            });
        });
    };
    Zilo.prototype.updateZiloState = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var contractState, stateOfContract, currentUser, userContribution, claimable, contributed, contractInit, newState;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.fetchContractState()];
                    case 1:
                        contractState = _e.sent();
                        return [4 /*yield*/, this.checkStatus(contractState)];
                    case 2:
                        stateOfContract = _e.sent();
                        currentUser = this.zilswap.getAppState().currentUser;
                        userContribution = (_a = contractState.contributions[currentUser || '']) !== null && _a !== void 0 ? _a : new bignumber_js_1.BigNumber(0);
                        claimable = stateOfContract === constants_1.ILOState.Completed && new bignumber_js_1.BigNumber(userContribution).isPositive();
                        contributed = userContribution.gt(0);
                        contractInit = (_b = this.appState) === null || _b === void 0 ? void 0 : _b.contractInit;
                        if (!!contractInit) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fetchContractInit()];
                    case 3:
                        contractInit = _e.sent();
                        if (!contractInit) {
                            console.error("Could not fetch contract init for Zilo " + this.contract.address);
                            return [2 /*return*/];
                        }
                        _e.label = 4;
                    case 4:
                        newState = {
                            contractState: contractState,
                            claimable: claimable,
                            contributed: contributed,
                            currentNonce: ((_c = this.appState) === null || _c === void 0 ? void 0 : _c.currentNonce) || 0,
                            currentUser: currentUser,
                            state: stateOfContract,
                            userContribution: userContribution,
                            contractInit: contractInit,
                        };
                        this.appState = newState;
                        (_d = this.stateObserver) === null || _d === void 0 ? void 0 : _d.call(this, newState);
                        return [2 /*return*/];
                }
            });
        });
    };
    Zilo.prototype.updateBlockHeight = function (height) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response, contractInit;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.appState) === null || _a === void 0 ? void 0 : _a.contractInit)) {
                            // not initialized, ignore update.
                            return [2 /*return*/];
                        }
                        if (!(typeof height === 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.zilswap.zilliqa.blockchain.getNumTxBlocks()];
                    case 1:
                        response = _b.sent();
                        height = parseInt(response.result, 10);
                        _b.label = 2;
                    case 2:
                        contractInit = this.appState.contractInit;
                        if (!(height === contractInit.start_block || height === contractInit.end_block)) return [3 /*break*/, 4];
                        // trigger update if start/end block is current height
                        return [4 /*yield*/, this.updateZiloState()];
                    case 3:
                        // trigger update if start/end block is current height
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Zilo.prototype.getZiloState = function () {
        if (!this.appState) {
            throw new Error('Zilo app state not loaded, call #initialize first.');
        }
        return this.appState;
    };
    /**
     * Checks the state of the current contract
     * ILOState.Uninitialized = Contract deployed but not initialized
     * ILOState.Pending = Contract initialized not stated (current block < start block)
     * ILOState.Active = Contract started
     * ILOState.Failed = Contract ended but target amount not reached
     * ILOState.Completed = Contract ended and target amount fufilled
     *
     * @param contractState
     * @returns returns the current ILOState
     */
    Zilo.prototype.checkStatus = function (contractState) {
        return __awaiter(this, void 0, void 0, function () {
            var contractInit, currentBlock;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchContractInit()];
                    case 1:
                        contractInit = _a.sent();
                        if (!contractInit || contractState.initialized.constructor !== 'True') {
                            return [2 /*return*/, constants_1.ILOState.Uninitialized];
                        }
                        currentBlock = this.zilswap.getCurrentBlock();
                        if (currentBlock < contractInit.start_block) {
                            return [2 /*return*/, constants_1.ILOState.Pending];
                        }
                        if (currentBlock < contractInit.end_block) {
                            return [2 /*return*/, constants_1.ILOState.Active];
                        }
                        if (new bignumber_js_1.BigNumber(contractInit.minimum_zil_amount).gt(new bignumber_js_1.BigNumber(contractState.total_contributions))) {
                            return [2 /*return*/, constants_1.ILOState.Failed];
                        }
                        else {
                            return [2 /*return*/, constants_1.ILOState.Completed];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Execute claim function if user contributed
     */
    Zilo.prototype.claim = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var claimTxn, deadline, observeTxn;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // Check init
                        this.zilswap.checkAppLoadedWithUser();
                        // check if current state is claimable
                        if (((_a = this.appState) === null || _a === void 0 ? void 0 : _a.state) !== constants_1.ILOState.Completed && ((_b = this.appState) === null || _b === void 0 ? void 0 : _b.state) !== constants_1.ILOState.Failed) {
                            throw new Error('Not yet claimable/refundable');
                        }
                        // no contribution
                        if (!((_c = this.appState) === null || _c === void 0 ? void 0 : _c.contributed)) {
                            throw new Error('User did not contribute');
                        }
                        return [4 /*yield*/, this.zilswap.callContract(this.contract, 'Claim', [], __assign(__assign({ amount: new util_1.BN(0) }, this.zilswap.txParams()), { gasLimit: util_1.Long.fromNumber(20000) }), true)];
                    case 1:
                        claimTxn = _d.sent();
                        if (claimTxn.isRejected()) {
                            throw new Error('Claim transaction was rejected.');
                        }
                        deadline = this.zilswap.deadlineBlock();
                        observeTxn = {
                            hash: claimTxn.id,
                            deadline: deadline,
                        };
                        return [4 /*yield*/, this.zilswap.observeTx(observeTxn)];
                    case 2:
                        _d.sent();
                        return [2 /*return*/, observeTxn];
                }
            });
        });
    };
    Zilo.prototype.complete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var completeTxn, deadline, observeTxn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.zilswap.checkAppLoadedWithUser();
                        return [4 /*yield*/, this.zilswap.callContract(this.contract, 'Complete', [], __assign({ amount: new util_1.BN(0) }, this.zilswap.txParams()), true)];
                    case 1:
                        completeTxn = _a.sent();
                        if (completeTxn.isRejected()) {
                            throw new Error('Complete transaction was rejected.');
                        }
                        deadline = this.zilswap.deadlineBlock();
                        observeTxn = {
                            hash: completeTxn.id,
                            deadline: deadline,
                        };
                        return [4 /*yield*/, this.zilswap.observeTx(observeTxn)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, observeTxn];
                }
            });
        });
    };
    /**
     * Contribute to the ILO, may need to increase token allowance before proceeding
     *
     * @param amountToContributeStr is the exact amount of ZIL to be contribute as a unitless string (without decimals).
     */
    Zilo.prototype.contribute = function (amountToContributeStr, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var amountToContribute, contributeTxn, deadline, observeTxn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.zilswap.checkAppLoadedWithUser();
                        amountToContribute = utils_1.unitlessBigNumber(amountToContributeStr);
                        return [4 /*yield*/, this.zilswap.callContract(this.contract, 'Contribute', [], __assign(__assign(__assign({ amount: new util_1.BN(amountToContribute.toString()) }, this.zilswap.txParams()), { gasLimit: util_1.Long.fromNumber(10000) }), opts), true)];
                    case 1:
                        contributeTxn = _a.sent();
                        if (contributeTxn.isRejected()) {
                            throw new Error('Contribute transaction was rejected.');
                        }
                        deadline = this.zilswap.deadlineBlock();
                        observeTxn = {
                            hash: contributeTxn.id,
                            deadline: deadline,
                        };
                        return [4 /*yield*/, this.zilswap.observeTx(observeTxn)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, observeTxn];
                }
            });
        });
    };
    return Zilo;
}());
exports.Zilo = Zilo;
//# sourceMappingURL=zilo.js.map